import React, {Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import ScheduleView from "../../widgets/ScheduleView";
import InsertMeetingWidget from "../../widgets/InsertMeetingWidget";
import EditMeetingWidget from "../../widgets/EditMeetingWidget";
import EditBreakWidget from "../../widgets/EditBreakWidget";
import GetInvestorService from '../../services/getInvestor';
import GetCompanyService from '../../services/getCompany';
import GetEventService from '../../services/getEvent';
import GetMeetingsService from '../../services/getMeetings';
import GetBreaksService from '../../services/getBreaks';
import GetInvestors from '../../services/getInvestorsAnalysts';
import GetCompanies from '../../services/getCompanies';
import ManageScheduleNotes from '../../services/manageScheduleNotes';
import moment from 'moment';
import Utils from '../../utils/utils';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { Button } from "@material-ui/core";
import draftToHtml from 'draftjs-to-html';


export default class Schedule extends React.Component {

  constructor(props){
    super (props);

    this.shouldUpdate = false;
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.linkClicked = false;
    this.renderCount = 0;

    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    this.titlePage = '';

    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];
    this.subjectName = '';
    this.eventDays = [];
    this.meetings = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      editorState: EditorState.createEmpty()
    }

    this.grid = 2;

    this.pageTitle = "Schedule";

    this.state = {
      newEventParam: {
        visible: false
      },
      editEventParam: {
        visible: false,
        meeting: undefined
      },
      editBreakParam: {
        visible: false,
        break: undefined
      }   
    };

  }

  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const scheduleType = cookies.get('scheduleType', { path: '/' });
    const scheduleSubject = cookies.get('scheduleSubject', { path: '/' });
    const eventId = cookies.get('currentEventId', { path: '/' });

    this.brokerFlag = cookies.get('brokerFlag', { path: '/' });

    this.scheduleType = scheduleType;
    this.scheduleSubject = scheduleSubject;
    this.savedEnabled = false;

    this.investor = await GetInvestorService(username, token, eventId, scheduleSubject);
    this.company = await GetCompanyService(username, token, eventId, scheduleSubject);
    this.event = await GetEventService(username, token, eventId);
    this.meetings = await GetMeetingsService(username, token, eventId);
    this.breaks = await GetBreaksService(username, token, eventId);
    this.investors = await GetInvestors(username, token, eventId, '');
    this.companies = await GetCompanies(username, token, eventId);

    if (scheduleType == 'investor') {
      this.subjectName = this.investor.name;
      this.titlePage = this.investor.name;
      this.notesRaw = this.investor.notesRaw;
      if (this.investor.company != '')
        this.titlePage += ' - ' + this.investor.company;      
    }
    else {
      this.titlePage = this.company.name;
      this.subjectName = this.company.name;
      this.notesRaw = this.company.notesRaw;
    }

    var editorState = EditorState.createEmpty();
    if (this.notesRaw != '') {
        var json = JSON.parse(this.notesRaw);
        editorState = EditorState.createWithContent(convertFromRaw(json));
    }

    var startDate = this.event.startDate;
    var endDate = this.event.endDate;

    startDate = moment(startDate, "DD/MM/yyyy");
    endDate = moment(endDate, "DD/MM/yyyy");

    this.eventDays = [];
    var tempDate = startDate;
    while (tempDate <= endDate){
      this.eventDays.push(moment(tempDate));
      tempDate = tempDate.add(1, 'd');
    }
    
    var contentState = {};
    var notes = this.notesRaw;
    if (notes != '') {
        var json = JSON.parse(notes);
        contentState = json;
    } else {
        notes = '{"blocks":[{"key":"","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';
        var json = JSON.parse(notes);
        contentState = json;
    }

    this.shouldUpdate = true;

    this.setState({      
      editEventParam: {
        visible: false,
        meeting: undefined,
      },
      contentState: contentState,
      editorState: editorState        
    });
  }

  onContentStateChange = contentState => {

    this.savedEnabled = true;
    var n = contentState;
    n.blocks.forEach((block) => {
      block.inlineStyleRanges.forEach((s) => {
          if (s.style !== 'BOLD' && s.style !== 'ITALIC' && s.style !== 'UNDERLINE' && !s.style.includes('color-rgb') && !s.style.includes('fontsize') && !s.style.includes('fontfamily')) {
              s.style = "";
          }
      })

      block.text = block.text.replace(/\n/g, '');
  });

    this.setState({ contentState: n });
  }

  async componentDidMount(){

    this.reload();
  }

  hideEditWindow () {
    this.linkClicked = true;
    this.setState({editEventParam: {visible: false }});
    this.setState({editBreakParam: {visible: false }});
  }

  shouldComponentUpdate() {

    if (this.shouldUpdate) {
      this.shouldUpdate = false;
      return true;
    }

    if (this.renderCount < 3) {
        this.renderCount += 1;
        return true;
    } else {
        return false;
    }
}

  render () {

    const cookies = new Cookies();
    const scheduleSubject = cookies.get('scheduleSubject', { path: '/' });

    const defaultFontValue = {
      fontFamily: 'Montserrat',
      fontSize: 21,
      color: '#555555'
    }

    var headCells = [
      { id: 'username', numeric: false, disablePadding: true, label: 'Username' },
      { id: 'name', numeric: true, disablePadding: false, label: 'Name' },
      { id: 'surname', numeric: true, disablePadding: false, label: 'Surname' },
    ];

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    this.linkClicked = false;

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title={this.pageTitle + " " + this.titlePage} />
        { 
          this.eventDays.map((v) => {
            let date = moment(v).format('DD/MM/yyyy');
            return (
            <div>
              <div>{date}</div>
              <ScheduleView 
                key={Math.random()}
                meetings={this.meetings} 
                breaks={this.breaks} 
                date={date} 
                parent={this}
                brokerFlag={this.brokerFlag}
                type={this.scheduleType}
                subject={scheduleSubject} 
                onMouseClick={(date, time) => {

                  this.shouldUpdate = true;
                  if (this.linkClicked == true) return;
                  
                  for (var i = 0; i < this.breaks.length; i++){

                    let b = this.breaks[i];
                    if (b.type != this.scheduleType) continue;
                    if (b.subject != this.scheduleSubject) continue;
                    if (b.date != date) continue;

                    var breakStart = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");
                    var breakEnd = moment(breakStart).add(parseInt(b.slots) * 5, 'minutes');

                    let currentClickTime = moment(date + " " + time, "DD/MM/yyyy HH:mm");
                    if (currentClickTime >= breakStart && breakEnd > currentClickTime) {

                      this.setState({
                        editBreakParam: {
                          visible: true,
                          break: b,
                        }
                      });

                      return;
                    }
                  }

                  for (var i = 0; i < this.meetings.length; i++){

                    let m = this.meetings[i];
                    if (this.scheduleType == 'investor' && Utils.checkInvestor(m.investors, scheduleSubject) == false) continue;
                    if (this.scheduleType == 'company' && m.company_id != scheduleSubject) continue;

                    var meetingStart = moment(m.date + " " + m.hour+":"+m.minutes, "DD/MM/yyyy HH:mm");
                    var meetingEnd = moment(meetingStart).add(parseInt(m.slots) * 5, 'minutes');

                    let currentClickTime = moment(date + " " + time, "DD/MM/yyyy HH:mm");
                    if (currentClickTime >= meetingStart && meetingEnd > currentClickTime) {

                      this.setState({
                        editEventParam: {
                          visible: true,
                          meeting: m,
                        }
                      });

                      return;
                    }
                  }

                  this.setState({
                    newEventParam: {
                      visible: true,
                      date: date,
                      time: time
                    }
                  });
                }}
              />
            </div> )
          })
        }
        {this.brokerFlag != "true" && 
        <div>Schedule notes:
        <div style={{border: '1px solid black', padding: '10px', background: '#ffffff'}}>
          <Editor
              contentState={this.state.contentState}
              onContentStateChange={this.onContentStateChange}
              onEditorStateChange={() => {}}
              toolbarClassName="demo-toolbar-custom"
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor-custom"
              toolbar={{
                  options: ['inline', 'fontSize', 'fontFamily', 'colorPicker', 'link'],       
                  inline: {
                      options: ['bold', 'italic', 'underline'],
                      bold: { className: 'bordered-option-classname' },
                      italic: { className: 'bordered-option-classname' },
                      underline: { className: 'bordered-option-classname' },
                  },
              }}
          />
        </div>

        <Button
            onClick={async () => {
              if (this.savedEnabled == false) return;

              const cookies = new Cookies();
              const username = cookies.get('username', { path: '/' });
              const token = cookies.get('token', { path: '/' });
              const scheduleType = cookies.get('scheduleType', { path: '/' });
              const scheduleSubject = cookies.get('scheduleSubject', { path: '/' });

              var notes = draftToHtml(this.state.contentState);
              const notesRaw = JSON.stringify(this.state.contentState);
              notes = notes.replace(/<p>/g, '<p style="line-height: normal; background-color: #ffffff">');
              notes = notes.replace(/><\/p>/g, '><br></p>');

              await ManageScheduleNotes(username, token, scheduleType, scheduleSubject, notes, notesRaw);

            }}
            style={{marginRight: 10, marginTop: 10}}
            variant="contained"
            size="large"
            color="secondary"
          >SAVE NOTES
          </Button>
          </div>
        }
        { this.state.editBreakParam.break && <EditBreakWidget 
          key={Math.random()}
          visible={this.state.editBreakParam.visible ? true : false}
          break={this.state.editBreakParam.break} 
          meetings={this.meetings} 
          breaks={this.breaks} 
          scheduleType={this.scheduleType}
          subjectName={this.subjectName}
          subjectId={scheduleSubject}
          investors={this.investors}
          companies={this.companies}
          onDone={() => {
            this.reload();
            this.setState({editBreakParam: {visible: false }});
          } }
        />
        }
        
        { this.state.editEventParam.meeting && <EditMeetingWidget 
          key={Math.random()}
          visible={this.state.editEventParam.visible ? true : false}
          meeting={this.state.editEventParam.meeting} 
          meetings={this.meetings} 
          breaks={this.breaks} 
          scheduleType={this.scheduleType}
          subjectName={this.subjectName}
          subjectId={scheduleSubject}
          investors={this.investors}
          companies={this.companies}
          onDone={() => {
            this.reload();
            this.setState({editEventParam: {visible: false }});
          } }
        />
        }

        <InsertMeetingWidget 
          key={Math.random()}
          visible={this.state.newEventParam.visible ? true : false}
          date={this.state.newEventParam.date}
          time={this.state.newEventParam.time}
          meetings={this.meetings} 
          breaks={this.breaks} 
          scheduleType={this.scheduleType}
          subjectName={this.subjectName}
          subjectId={scheduleSubject}
          investors={this.investors}
          companies={this.companies}
          onDone={() => {
            this.reload();
            this.setState({newEventParam: {visible: false }});
          } }
        />
        </LoadingOverlay>
      </>
    );
  }

}

